import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgMoreIos(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M4.24463 10C3.00495 10 2 11.0074 2 12.25C2 13.4926 3.00495 14.5 4.24463 14.5C5.4843 14.5 6.48926 13.4926 6.48926 12.25C6.48926 11.0074 5.4843 10 4.24463 10Z", fill: "currentColor" }),
        React.createElement("path", { d: "M19.7554 10C18.5157 10 17.5107 11.0074 17.5107 12.25C17.5107 13.4926 18.5157 14.5 19.7554 14.5C20.995 14.5 22 13.4926 22 12.25C22 11.0074 20.995 10 19.7554 10Z", fill: "currentColor" }),
        React.createElement("path", { d: "M12 10C10.7603 10 9.75537 11.0074 9.75537 12.25C9.75537 13.4926 10.7603 14.5 12 14.5C13.2397 14.5 14.2446 13.4926 14.2446 12.25C14.2446 11.0074 13.2397 10 12 10Z", fill: "currentColor" })));
}
export default SvgMoreIos;
